"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initIconConfig = void 0;
const SvgIcon_vue_1 = __importDefault(require("./SvgIcon.vue")); // svg component
const defaultContext = require.context('./data', false, /\.svg$/);
const initIconConfig = function (app, pageContent) {
    // register globally
    app.component('svg-icon', SvgIcon_vue_1.default);
    defaultContext.keys().map(defaultContext);
    if (pageContent) {
        pageContent.keys().map(pageContent);
    }
};
exports.initIconConfig = initIconConfig;
